const {
  VITE_REACT_APP_API_KEY = '', VITE_REACT_APP_PROJECT_ID = '',
  VITE_REACT_APP_SENDER_ID = '', VITE_REACT_APP_APP_ID = '',
  VITE_REACT_APP_MEASUREMENT_ID = ''
} = import.meta.env

export const config = {
  apiKey: VITE_REACT_APP_API_KEY,
  authDomain: `${VITE_REACT_APP_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${VITE_REACT_APP_PROJECT_ID}.firebaseio.com`,
  projectId: VITE_REACT_APP_PROJECT_ID,
  storageBucket: `${VITE_REACT_APP_PROJECT_ID}.appspot.com`,
  messagingSenderId: VITE_REACT_APP_SENDER_ID,
  appId: VITE_REACT_APP_APP_ID,
  measurementId: `G-${VITE_REACT_APP_MEASUREMENT_ID}`
}
